import React from "react";
import { Stack } from "@mui/material";

import { DesiredPrompts } from "./DesiredPrompts/DesiredPrompts";
import { SelectedCommands } from "./SelectedCommands/SelectedCommands";
import { TextTransformation } from "./TextTransformation/TextTransformation";
import { AgenticWorkflow } from "./AgenticWorkflow/AgenticWorkflow";

export const WBGifSections: React.FC = () => {
  return (
    <Stack
      width={1}
      direction="column"
      gap={16}
      sx={{
        gap: {
          md: 16,
          xs: 4,
        },
      }}
    >
      <TextTransformation />

      <SelectedCommands />

      <DesiredPrompts />

      <AgenticWorkflow />
    </Stack>
  );
};
